import { launch } from "./Launch";
const sdk = { launch };
export { sdk as CasinoSlimSdk };
//# sourceMappingURL=index.js.map